
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './styles/styles.scss';

const Dropdown = (props) => {
  const { label } = props;

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toglleDropdown = (e) => {
    const prevState = dropdownOpen;
    setDropdownOpen(!prevState);
    e.preventDefault();
  };

  const dropDownClass = dropdownOpen ? 'dropdown open' : 'dropdown';

  return (
    <div className={dropDownClass}>
      <div
        className="dropdown-toggle"
        onClick={toglleDropdown}
      >
        {label}
      </div>
      <ul className="dropdown-menu">
        {props.children}
      </ul>
    </div>
  );
};

Dropdown.propTypes = {
  label: PropTypes.any,
  children: PropTypes.any,
};
export default Dropdown;

